import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.featured);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">编辑精选，不容错过的优质内容</p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featured.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}